/* eslint-disable import/prefer-default-export */

export const COUPON_CHECK_WAIT = 300;
export const EMAIL_CHECK_WAIT = 300;
export const TIMEOUT = 500;
export const NOT_INCLUDED_INDEX = -1;
export const HUMAN_JOIN_MAX = 3;
